import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const aboutData: NavItem[] = [
  {
    label: 'Hero',
    to: '/pages/about/hero'
  },
  {
    label: 'Vision-top',
    to: '/pages/about/visionTop'
  },
  {
    label: 'Vision-bottom',
    to: '/pages/about/visionBottom'
  },
  {
    label: 'Report',
    to: '/pages/about/report'
  },
  {
    label: 'Teams',
    to: '/pages/about/teams'
  }
];
